import React from 'react';
import { Table, Button, Tabs } from 'antd';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';

const { TabPane } = Tabs;

class ProviderBookings extends React.Component {
  state = {
    list: [],
    loading: true,
  };

  componentDidMount() {
    this.fetchList(this.tabs[0].key);
  }

  breadcrumbs = [
    { name: 'Home', to: '/provider' },
    { name: 'Manage bookings' },
  ];

  tabs = [
    {
      name: 'Active bookings',
      key: 'active',
    },
    {
      name: 'History',
      key: 'history',
    },
  ];

  columns = [
    {
      title: 'Contract number',
      dataIndex: 'Plan.contractNumber',
      key: 'contract_number',
    },
    {
      title: 'URN',
      dataIndex: 'Plan.VRN',
      key: 'urn',
    },
    {
      title: 'Driver',
      dataIndex: 'Plan.Customer.lastName',
      key: 'driver',
    },
    {
      title: 'Booking type',
      dataIndex: 'type',
      key: 'booking_type',
    },
    {
      title: 'Status',
      dataIndex: 'BookingStatus.garageMessage',
      key: 'booking_type',
    },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'Plan.id',
      render: id => (
        <Link to={`/provider/bookings/${id}`}>
          <Button type="primary" className={s.actionButton}>
            Manage
          </Button>
        </Link>
      ),
    },
  ];

  fetchList = async type => {
    try {
      this.setState({ loading: true });

      const list = await fetch(`/provider/bookings-list/${type}`);

      this.setState({ list, loading: false });
    } catch (e) {
      // do onthing
    }
  };

  renderTable = () => {
    const { list, loading } = this.state;

    return (
      <Table
        loading={loading}
        columns={this.columns}
        rowKey="id"
        dataSource={list}
      />
    );
  };

  render() {
    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.title}>Service Plans Bookings</div>
        <Tabs
          defaultActiveKey={this.tabs[0].key}
          onChange={this.fetchList}
          type="card"
        >
          {this.tabs.map(tab => (
            <TabPane tab={tab.name} key={tab.key}>
              {this.renderTable()}
            </TabPane>
          ))}
        </Tabs>
      </NavBar>
    );
  }
}

export default ProviderBookings;
